export default "__VITE_ASSET__8726f805__"